import { Pressable, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IBGeneralTable } from '../../../../../common'
import { pipe } from 'fp-ts/lib/function'
import { DocsData, DocumentsTabsData, IBService } from '../../../../../ib-service'
import { ZIO } from '@mxt/zio'
import { isEmpty, orderBy } from 'lodash'
import moment from 'moment'
import { useLoading } from '@mxt/zio-react'
import { downloadURI } from '@pulseops/common'

interface Props {
  data: DocumentsTabsData
  setData: (data: DocumentsTabsData) => void
  policyNumber: string
}

export const IBEInvoiceDocs = (props: Props) => {
  const { data, setData, policyNumber } = props
  const { t, i18n } = useTranslation('Inbound')
  const [loading, bindLoading] = useLoading(false)
  const dataTable = [
    {
      label: t('ReceiptNumber'),
      field: 'receiptnum',
      render: (value: string, index: number) => {
        return (
          <Pressable
            onPress={() => {
              const object = (data.EInvoiceDocs as DocsData[])[index]
              pipe(
                IBService.downloadURL(object.url as string),
                ZIO.flatMap((res) => {
                  return ZIO.zipPar(
                    ZIO.succeed(res),
                    ZIO.fromPromise(() => res.blob())
                  )
                }),
                ZIO.tap(([res, blob]) => {
                  const type = res.headers.get('content-type') || ''
                  downloadURI(window.URL.createObjectURL(blob), `file.${type.split('/')[1]}`)
                  return ZIO.unit
                }),
                ZIO.unsafeRun({})
              )
            }}
          >
            <Text
              style={{
                fontWeight: '600',
                fontSize: 15,
                color: '#1ea5fc',
                textDecorationLine: 'underline'
              }}
            >
              {value}
            </Text>
          </Pressable>
        )
      }
    },
    {
      label: t('ReceiptAmount'),
      field: 'receiptamount',
      format: 'money'
    },
    {
      label: t('ReceiptDate'),
      field: 'receiptdate',
      format: 'date'
    },
    {
      label: t('TaxNum'),
      field: 'taxnum'
    },
    {
      label: t('TR_RB_NUM'),
      field: 'tr_rb_num'
    },
    {
      label: t('AddedOn'),
      field: 'datecreated',
      format: 'dateTime'
    },
    {
      label: t('ModifiedOn'),
      field: 'datelastmodified',
      format: 'dateTime'
    }
  ]

  React.useEffect(() => {
    if (isEmpty(data.EInvoiceDocs)) {
      pipe(
        IBService.getDocsList(policyNumber, 'E-INVOICE'),
        ZIO.map((res) => {
          if (res.data) {
            setData({ ...data, EInvoiceDocs: res.data })
          }
        }),
        bindLoading,
        ZIO.unsafeRun({})
      )
    }
  }, [])

  return (
    <View>
      <IBGeneralTable
        data={
          orderBy(
            data.EInvoiceDocs?.map((item) => ({
              ...item.metaData,
              datecreated: moment(item.metaData.datecreated, 'DD/MM/YYYY HH:mm:ss').format('YYYYMMDDHHmmss'),
              datelastmodified: moment(item.metaData.datelastmodified, 'DD/MM/YYYY HH:mm:ss').format('YYYYMMDDHHmmss'),
              receiptdate: moment(item.metaData.receiptdate, 'DD/MM/YYYY').format('YYYYMMDD')
            })),
            'datecreated',
            'desc'
          ) || []
        }
        dataTable={dataTable}
        paginationStyle={{ marginRight: 60 }}
        loading={loading}
        autoPaging
      />
    </View>
  )
}

const styles = StyleSheet.create({})
